export enum NotificationType {
    ESTIMATION_TO_CERTIFICATE = 1,
    REVIEW_ADDED = 2,
    ESTIMATION_APPROVED = 3,
    ESTIMATION_REJECTED = 4,
    ESTIMATION_TO_FIX = 5,
} 

type NotificationTypeMeta = {
  code: string;
  label: string;
  icon: string;
};

// Mapping from enum value to display label
export const NotificationTypeLabels: Record<NotificationType, NotificationTypeMeta> = {
    [NotificationType.ESTIMATION_TO_CERTIFICATE]: { code: "ESTIMATION_TO_CERTIFICATE", label: "Pending certification", icon: "⏳" },
    [NotificationType.REVIEW_ADDED]: { code: "REVIEW_ADDED", label: "Review Added", icon: "📝" },
    [NotificationType.ESTIMATION_APPROVED]: { code: "ESTIMATION_APPROVED", label: "Approved", icon: "✅" },
    [NotificationType.ESTIMATION_REJECTED]: { code: "ESTIMATION_REJECTED", label: "Rejected", icon: "❌" },
    [NotificationType.ESTIMATION_TO_FIX]: { code: "ESTIMATION_TO_FIX", label: "To Fix", icon: "⚠️" }
};

